// ========================================
// Professor Nominas View
// ========================================

const ProfessorNominas = {
    // Shared history key
    HISTORY_KEY: 'ecpv_payroll_history',
    course: null, // start year of the course on screen

    render() {
        const currentUser = AuthManager.currentUser;
        // Always one's own payslips: admin and RRHH reach this as «Mi nómina» (their «Nóminas» is everybody's).
        const hasAccess = currentUser && currentUser.professorId;

        if (!hasAccess) {
            return `
                <div class="view-container dnr-proposal nom-view" style="padding-top: 1rem;">
                    <style ${SafeHTML.styleAttr}>.nom-view { gap: 0; }</style>
                    <div class="dnr-empty" style="padding: 5rem 1rem; text-align: center;">
                        <i class="fas fa-exclamation-circle" style="font-size: 3rem; color: var(--dnr-ink-faint); margin-bottom: 1.5rem;"></i>
                        <h3 style="font-family: var(--dnr-display); font-weight: 400; font-size: 1.5rem; color: var(--dnr-ink); margin: 0 0 0.5rem 0;">Acceso Restringido</h3>
                        <p style="color: var(--dnr-ink-mute); margin: 0;">Tu cuenta no está enlazada a una ficha de personal, así que no hay nóminas tuyas que mostrar.</p>
                    </div>
                </div>
            `;
        }

        return `
            <div class="view-container dnr-proposal payroll-view pn-mine">
                <div class="pn-page-head">
                    <div>
                        <h1 class="pn-page-title">Mis nóminas</h1>
                        <p class="pn-hint">Tus nóminas mes a mes y tus contratos. Puedes verlos y descargarlos cuando quieras.</p>
                    </div>
                    <select class="pn-select" id="mine-course-select" aria-label="Curso" ${UIEvents.attr("change", function(event,captured){ProfessorNominas.course=Number(this.value);ProfessorNominas.renderHistory();}, [])}></select>
                </div>
                <div id="professor-nominas-container" class="pn-stack"></div>
            </div>

            <!-- Modal Preview (Reusing same style as NominasUpload) -->
            <div id="payroll-modal" class="modal-overlay" style="display: none; position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.85); z-index: 9999; backdrop-filter: blur(4px); align-items: center; justify-content: center; opacity: 0; transition: opacity 0.3s ease;">
                <div class="dnr-proposal modal-container" style="gap: 0; margin-bottom: 0; width: 90%; max-width: 1000px; height: 90%; background: var(--dnr-surface); border-radius: 16px; position: relative; display: flex; flex-direction: column; overflow: hidden; box-shadow: 0 20px 50px rgba(0,0,0,0.5); transform: scale(0.9); transition: transform 0.3s ease;">
                    <div class="modal-header" style="padding: 1rem 1.5rem; background: var(--dnr-surface-sunken); border-bottom: 1px solid var(--dnr-line); display: flex; justify-content: space-between; align-items: center;">
                        <h3 id="modal-doc-title" style="margin: 0; font-size: 1.1rem; color: var(--dnr-ink);">Vista Previa</h3>
                        <div style="display: flex; gap: 0.75rem;">
                            <button id="modal-download-btn" class="btn btn-sm btn-primary" style="padding: 0.5rem 1rem;">
                                <i class="fas fa-download"></i> Descargar
                            </button>
                            <button ${UIEvents.attr("click", function(event,captured){ProfessorNominas.closeModal();}, [])} class="btn-icon" style="color: var(--dnr-ink-mute); font-size: 1.25rem;">
                                <i class="fas fa-times"></i>
                            </button>
                        </div>
                    </div>
                    <div id="modal-doc-content" style="flex: 1; display: flex; align-items: center; justify-content: center; background: var(--dnr-surface-sunken); overflow: auto; padding: 1rem;">
                        <!-- Content injected here -->
                    </div>
                </div>
            </div>
        `;
    },

    init() {
        this.renderHistory();

        // Modal events
        window.onclick = (e) => {
            const modal = document.getElementById('payroll-modal');
            if (e.target === modal) this.closeModal();
        };
    },

    getHistory() {
        let history = [];
        if (window.FileStorage) {
            history = FileStorage.read ? (FileStorage.read(this.HISTORY_KEY) || []) : (FileStorage.dataStore.payrollHistory || []);
        } else {
            const data = BrowserState.getItem(this.HISTORY_KEY);
            history = data ? JSON.parse(data) : [];
        }
        const currentUser = AuthManager.currentUser;

        // Only one's own, whatever the role (the server sends admin and RRHH everybody's).
        if (currentUser && currentUser.professorId) {
            return history.filter(h => h.professorId === currentUser.professorId);
        }
        return [];
    },

    /** Start year of the course a month belongs to (a course runs September to August). */
    courseOf(month, year) {
        return Number(month) >= 9 ? Number(year) : Number(year) - 1;
    },

    /** «Mis contratos»: each hire of the person, with its signed PDF to read or download. */
    contractsHTML() {
        const me = typeof DataManager !== 'undefined' ? DataManager.getProfessor(AuthManager.currentUser?.professorId) : null;
        const contracts = StaffPay.contractsOf(me).filter(c => c.id).reverse();
        if (!contracts.length) return '';
        const fmt = iso => new Date(`${iso}T12:00:00`).toLocaleDateString('es-ES', { day: 'numeric', month: 'short', year: 'numeric' });
        return `<section class="pn-card pn-table-card" aria-labelledby="mine-contracts-title">
            <div class="pn-table-head">
                <h2 class="pn-title" id="mine-contracts-title">Mis contratos</h2>
                <span class="pn-hint">Los más recientes primero</span>
            </div>
            <div class="pn-scroll">
                <table class="pn-table pn-table-mine">
                    <thead><tr><th scope="col">Contrato</th><th scope="col">Puesto y jornada</th><th scope="col" class="pn-num"><span class="sr-only">Acciones</span></th></tr></thead>
                    <tbody>${contracts.map(c => `<tr>
                        <td><div class="pn-person">
                            <span class="pn-file">PDF</span>
                            <span class="pn-person-text"><span class="pn-person-name">${fmt(c.startDate)} – ${c.endDate ? fmt(c.endDate) : 'sin fecha de fin'}</span>${c.contractKind ? `<span class="pn-person-kind">${Utils.sanitizeHTML(c.contractKind)}</span>` : ''}</span>
                        </div></td>
                        <td class="pn-when">${Utils.sanitizeHTML([c.position, c.workingTime].filter(Boolean).join(' · ') || '—')}</td>
                        <td class="pn-num">${c.documentFilePath ? `<div class="pn-actions">
                            <button type="button" class="btn btn-sm btn-secondary" ${UIEvents.attr("click", function(event,captured){ContractDocs.view(String(captured[0]),String(captured[1]));}, [c.documentFilePath, `Contrato · ${fmt(c.startDate)}`])}><i class="fas fa-eye"></i> Ver</button>
                            <button type="button" class="btn btn-sm btn-primary" ${UIEvents.attr("click", function(event,captured){ContractDocs.download(String(captured[0]));}, [c.documentFilePath])}><i class="fas fa-download"></i> Descargar</button>
                        </div>` : '<span class="pn-hint">Aún sin PDF</span>'}</td>
                    </tr>`).join('')}</tbody>
                </table>
            </div>
        </section>`;
    },

    renderHistory() {
        const container = document.getElementById('professor-nominas-container');
        const select = document.getElementById('mine-course-select');
        if (!container) return;

        const history = this.getHistory().slice().sort((a, b) => (Number(b.year) * 12 + Number(b.monthIndex)) - (Number(a.year) * 12 + Number(a.monthIndex)));
        const now = new Date(), nowKey = now.getFullYear() * 12 + now.getMonth() + 1;
        const money = n => n == null ? '—' : Utils.formatCurrency(n);
        const courses = [...new Set([this.courseOf(now.getMonth() + 1, now.getFullYear()), ...history.map(h => this.courseOf(h.monthIndex, h.year))])].sort((a, b) => b - a);
        if (!this.course || !courses.includes(this.course)) this.course = history.length ? this.courseOf(history[0].monthIndex, history[0].year) : courses[0];
        if (select) SafeHTML.set(select, courses.map(y => `<option value="${y}" ${y === this.course ? 'selected' : ''}>Curso ${y} / ${y + 1}</option>`).join(''));

        if (history.length === 0) {
            SafeHTML.set(container, `
                <div class="dnr-empty pn-card" style="padding: 4rem 1rem; text-align: center;">
                    <i class="fas fa-file-invoice-dollar" style="font-size: 2rem; color: var(--dnr-teal-600); display: block; margin-bottom: 1rem;"></i>
                    <h3 class="pn-title" style="margin-bottom: 0.4rem;">Aún no hay nóminas disponibles</h3>
                    <p class="pn-hint">Tus nóminas aparecerán aquí en cuanto RRHH las suba.</p>
                </div>${this.contractsHTML()}`);
            return;
        }

        // The course's twelve months: open the payslip, this month still running, or nothing yet.
        const names = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
        const chips = [9, 10, 11, 12, 1, 2, 3, 4, 5, 6, 7, 8].map(month => {
            const year = month >= 9 ? this.course : this.course + 1;
            const h = history.find(item => Number(item.monthIndex) === month && String(item.year) === String(year));
            const key = year * 12 + month, label = names[month - 1].slice(0, 3);
            if (h) return `<button type="button" class="pn-month is-active" aria-label="Ver la nómina de ${names[month - 1]} ${year}" ${UIEvents.attr("click", function(event,captured){ProfessorNominas.viewDocument(String(captured[0]));}, [h.timestamp])}>
                <span class="pn-month-label">${label}</span><span class="pn-month-count">${h.netPay != null ? `${Math.round(h.netPay).toLocaleString('es-ES')} €` : 'Ver'}</span></button>`;
            const state = key === nowKey ? 'is-current' : key > nowKey ? 'is-future' : '';
            return `<span class="pn-month ${state}" aria-label="${names[month - 1]} ${year}: ${key === nowKey ? 'en curso' : 'sin nómina'}">
                <span class="pn-month-label">${label}</span>${key === nowKey ? '<span class="pn-month-note">En curso</span>' : '<span class="pn-month-count">—</span>'}</span>`;
        }).join('');

        // Figures: the latest payslip, and the calendar year so far (what the tax return asks for).
        const last = history[0], thisYear = String(now.getFullYear());
        const ofYear = history.filter(h => String(h.year) === thisYear);
        // A settlement (finiquito) is also money of that year: its «Suma» is gross, its net is net.
        const settled = (h, key) => !h.settlementFilePath ? 0 : Number(key === 'netPay' ? h.settlementNet : h.settlementCost) || 0;
        const sum = key => ofYear.reduce((s, h) => s + (Number(h[key]) || 0) + settled(h, key), 0);
        const span = ofYear.length ? `${ofYear.length} ${ofYear.length === 1 ? 'nómina' : 'nóminas'}, de ${names[Math.min(...ofYear.map(h => Number(h.monthIndex))) - 1].toLowerCase()} a ${names[Math.max(...ofYear.map(h => Number(h.monthIndex))) - 1].toLowerCase()}` : 'Aún ninguna este año';
        const fresh = Date.now() - new Date(last.timestamp).getTime() < 45 * 86400000;
        const uploaded = ts => { const d = new Date(ts); return Number.isNaN(d.getTime()) ? '' : d.toLocaleDateString('es-ES', { day: 'numeric', month: 'short', year: 'numeric' }); };

        SafeHTML.set(container, `
            <section class="pn-card pn-months" aria-label="Meses del curso">
                <div class="pn-row-between">
                    <span class="pn-mono-note">Curso ${this.course} / ${this.course + 1}</span>
                    <span class="pn-hint">Pulsa un mes para abrir su nómina</span>
                </div>
                <div class="pn-month-grid">${chips}</div>
            </section>
            <div class="pn-stats pn-stats-3">
                <div class="pn-stat pn-stat-hero">
                    <span class="pn-stat-label">Última nómina · ${Utils.sanitizeHTML(last.month)}</span>
                    <span class="pn-stat-value">${money(last.netPay)}</span>
                    <span class="pn-stat-sub">${last.netPay != null ? 'Líquido cobrado' : 'Líquido sin leer'}${last.grossPay != null ? ` · Bruto ${money(last.grossPay)}` : ''}</span>
                </div>
                <div class="pn-stat">
                    <span class="pn-stat-label">Líquido del año ${thisYear}</span>
                    <span class="pn-stat-value">${money(sum('netPay'))}</span>
                    <span class="pn-stat-sub">${span}</span>
                </div>
                <div class="pn-stat">
                    <span class="pn-stat-label">Bruto del año ${thisYear}</span>
                    <span class="pn-stat-value">${money(sum('grossPay'))}</span>
                    <span class="pn-stat-sub">Útil para la declaración de la renta</span>
                </div>
            </div>
            <section class="pn-card pn-table-card" aria-labelledby="mine-title">
                <div class="pn-table-head">
                    <h2 class="pn-title" id="mine-title">Todas mis nóminas</h2>
                    <span class="pn-hint">Las más recientes primero</span>
                </div>
                <div class="pn-scroll">
                    <table class="pn-table pn-table-mine">
                        <thead><tr>
                            <th scope="col">Mes</th>
                            <th scope="col" class="pn-num">Líquido</th>
                            <th scope="col" class="pn-num">Bruto</th>
                            <th scope="col">Disponible desde</th>
                            <th scope="col" class="pn-num"><span class="sr-only">Acciones</span></th>
                        </tr></thead>
                        <tbody>
                            ${history.map((h, i) => `<tr>
                                <td><div class="pn-person">
                                    <span class="pn-file ${String(h.fileType).includes('pdf') ? '' : 'is-image'}">${String(h.fileType).includes('pdf') ? 'PDF' : 'IMG'}</span>
                                    <span class="pn-person-text"><span class="pn-person-name">${Utils.sanitizeHTML(h.month)} ${Utils.sanitizeHTML(h.year)}</span>${h.isInvoice ? '<span class="pn-person-kind" title="Líquido: lo que se te paga, sin la retención. Bruto: la base imponible.">Factura</span>' : ''}${i === 0 && fresh ? '<span class="pn-new">Nueva</span>' : ''}</span>
                                </div></td>
                                <td class="pn-num pn-cost">${money(h.netPay)}</td>
                                <td class="pn-num pn-soft">${money(h.grossPay)}</td>
                                <td class="pn-when">${uploaded(h.timestamp)}</td>
                                <td class="pn-num"><div class="pn-actions">
                                    <button type="button" class="btn btn-sm btn-secondary" ${UIEvents.attr("click", function(event,captured){ProfessorNominas.viewDocument(String(captured[0]));}, [h.timestamp])}><i class="fas fa-eye"></i> Ver</button>
                                    <button type="button" class="btn btn-sm btn-primary" ${UIEvents.attr("click", function(event,captured){ProfessorNominas.downloadDocument(String(captured[0]));}, [h.timestamp])}><i class="fas fa-download"></i> Descargar</button>
                                </div></td>
                            </tr>${h.settlementFilePath ? `<tr class="pn-settle-row">
                                <td><div class="pn-person">
                                    <span class="pn-file">PDF</span>
                                    <span class="pn-person-text"><span class="pn-person-name">Finiquito · ${Utils.sanitizeHTML(h.month)} ${Utils.sanitizeHTML(h.year)}</span>${h.settlementDate ? `<span class="pn-person-kind">Cese el ${Utils.sanitizeHTML(new Date(`${h.settlementDate}T12:00:00`).toLocaleDateString('es-ES', { day: 'numeric', month: 'long' }))}</span>` : ''}</span>
                                </div></td>
                                <td class="pn-num pn-cost">${money(h.settlementNet)}</td>
                                <td class="pn-num pn-soft">${money(h.settlementCost)}</td>
                                <td class="pn-when">${uploaded(h.timestamp)}</td>
                                <td class="pn-num"><div class="pn-actions">
                                    <button type="button" class="btn btn-sm btn-secondary" ${UIEvents.attr("click", function(event,captured){ProfessorNominas.viewDocument(String(captured[0]),true);}, [h.timestamp])}><i class="fas fa-eye"></i> Ver</button>
                                    <button type="button" class="btn btn-sm btn-primary" ${UIEvents.attr("click", function(event,captured){ProfessorNominas.downloadDocument(String(captured[0]),true);}, [h.timestamp])}><i class="fas fa-download"></i> Descargar</button>
                                </div></td>
                            </tr>` : ''}`).join('')}
                        </tbody>
                    </table>
                </div>
            </section>
            ${this.contractsHTML()}
        `);
    },

    /** A payslip, or the settlement (finiquito) attached to it, as a document to open. */
    documentOf(timestamp, settlement) {
        const item = this.getHistory().find(h => h.timestamp === timestamp);
        if (!item || !settlement) return item;
        return item.settlementFilePath ? { ...item, filePath: item.settlementFilePath, fileName: item.settlementFileName || 'Finiquito.pdf', fileType: 'application/pdf', fileData: null, label: 'Finiquito' } : null;
    },

    async viewDocument(timestamp, settlement = false) {
        const item = this.documentOf(timestamp, settlement);
        if (item) {
            // A payslip with a settlement opens with the settlement's pages after it.
            const joined = !settlement && await NominasBatch.payslipWithSettlement(item).catch(e => { console.warn('Payslip + settlement:', e); return null; });
            if (joined) {
                if (this._privatePreviewUrl) URL.revokeObjectURL(this._privatePreviewUrl);
                this._privatePreviewUrl = joined;
                this.openModal({ ...item, fileData: joined, fileType: 'application/pdf', fileName: NominasBatch.joinedName(item), label: 'Nómina y finiquito' });
            } else if (item.filePath) {
                await PrivateDownloads.preview('/' + item.filePath.replace(/^\//, ''), url => {
                    if (this._privatePreviewUrl) URL.revokeObjectURL(this._privatePreviewUrl);
                    this._privatePreviewUrl = url;
                    this.openModal({ ...item, fileData: url });
                });
            } else if (item.fileData) {
                this.openModal(item);
            } else {
                Utils.showToast('No se puede abrir el archivo', 'error');
            }
        } else {
            Utils.showToast('Registro no encontrado', 'error');
        }
    },

    async downloadDocument(timestamp, settlement = false) {
        const item = this.documentOf(timestamp, settlement);
        if (item) {
            const joined = !settlement && await NominasBatch.payslipWithSettlement(item).catch(() => null);
            if (joined) {
                this._triggerDownload(joined, NominasBatch.joinedName(item));
                setTimeout(() => URL.revokeObjectURL(joined), 60000);
            } else if (item.filePath) {
                PrivateDownloads.download('/' + item.filePath.replace(/^\//, ''));
            } else if (item.fileData) {
                this._triggerDownload(item.fileData, item.fileName);
            } else {
                Utils.showToast('No se puede descargar el archivo', 'error');
            }
        } else {
            Utils.showToast('Registro no encontrado', 'error');
        }
    },

    _triggerDownload(url, name) {
        const link = document.createElement('a');
        link.href = url;
        link.download = name;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        Utils.showToast('Descarga iniciada', 'success');
    },

    openModal(item) {
        const modal = document.getElementById('payroll-modal');
        // Lives on <body> while open: inside the view «fixed» would be relative to the view
        // (see NominasUpload.openModal); an older copy left there goes away.
        document.querySelectorAll('body > #payroll-modal').forEach(old => { if (old !== modal) old.remove(); });
        if (modal.parentElement !== document.body) document.body.append(modal);
        const title = document.getElementById('modal-doc-title');
        const content = document.getElementById('modal-doc-content');
        const downloadBtn = document.getElementById('modal-download-btn');

        title.textContent = `${item.label || 'Nómina'} ${item.month} ${item.year}`;

        let previewUrl;
        try { previewUrl = PrivateDownloads.renderInlinePreview(content, item.fileData, item.fileType); }
        catch (error) { Utils.showToast(error.message, 'error'); return; }
        downloadBtn.onclick = () => this._triggerDownload(previewUrl, item.fileName);

        modal.style.display = 'flex';
        setTimeout(() => {
            modal.style.opacity = '1';
            modal.querySelector('.modal-container').style.transform = 'scale(1)';
        }, 10);
    },

    closeModal() {
        PrivateDownloads.clearInlinePreview(document.getElementById('modal-doc-content'));
        if (this._privatePreviewUrl) URL.revokeObjectURL(this._privatePreviewUrl);
        this._privatePreviewUrl = null;
        const modal = document.getElementById('payroll-modal');
        modal.style.opacity = '0';
        modal.querySelector('.modal-container').style.transform = 'scale(0.9)';
        setTimeout(() => {
            modal.style.display = 'none';
            SafeHTML.set(document.getElementById('modal-doc-content'), '');
        }, 300);
    }
};

window.ProfessorNominas = ProfessorNominas;
